<div class="p-2">
    <div class="d-flex justify-content-between align-items-center">
        <span class="promo-title">{{ "POLYGON_EDITOR_COMPONENT_TITLE" | translate }}</span>
        <button (click)="onDelete()" class="promo-delete">
            <img src="assets/img/trash.png" class="delete-img" />
        </button>
    </div>
    <forms #formNursery [formInfo]="formInfo"> </forms>
    <form class="w-100 mt-3" *ngIf="selectedProductMeasures">
        <span class="marker-title">{{ "PRODUCT_DETAIL_MEASURES_PLACEHOLDER" | translate }}</span>
        <ng-multiselect-dropdown
            [placeholder]="'PRODUCT_DETAIL_MEASURES_PLACEHOLDER' | translate"
            [data]="selectedProductMeasures"
            [(ngModel)]="selectedProductMeasure"
            [settings]="productMeasuresDropdownSettings"
            name="product-measure-id"
            class="w-100 px-2 rounded-1"
        >
        </ng-multiselect-dropdown>
    </form>
    <div class="d-flex justify-content-center mt-3">
        <button (click)="onSave()" [disabled]="!this.formComponent.form.value.product" class="btn w-75 green-btn">
            {{ "POLYGON_EDITOR_COMPONENT_SAVE" | translate }}
        </button>
    </div>
</div>
